import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-left-front-fender',
    templateUrl: './question-damage-image-left-front-fender.component.html',
    styleUrls: ['./question-damage-image-left-front-fender.component.scss'],
    standalone: false
})
export class QuestionDamageImageLeftFrontFenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
